import {
  getGalleryOrganizationsImages,
  getGalleryEmailsImages,
  getGalleryPublicImages,
  getGalleryProtracksImages,
  getSearchAtActivitiesImages,
  getGallerySprintsImages,
} from 'store/entities/gallery/selectors'
import { getVideosList } from 'store/entities/videos/selectors'

export const ORGANIZATION_MAIN_LOGO_IMAGE = 'organization-main-logo-image'
export const ORGANIZATION_EMAIL_LOGO_IMAGE = 'organization-email-logo-image'
export const WELCOME_EMAIL = 'welcome-email'
export const ORG_INACTIVE_NOTIFICATIONS = 'org-inactive-notifications'
export const PROTRACK_LEVEL_IMAGE = 'protrack-level-image'
export const ACTIVITY_IMAGE = 'activity-image'
export const ACTIVITY_VIDEO = 'activity-video'
export const PROTRACK_LEVEL_WELCOME_EMAIL_IMAGE = 'protrack-level-welcome-email-image'
export const IMAGE_MESSAGING = 'image-messaging'
export const PROMO_PAGE_SETTINGS = 'promo-page-settings'
export const SPRINT_BADGE = 'sprint-badge'

const ORGANIZATIONS = 'organizations'
const EMAILS = 'emails'
const PUBLIC = 'public'
const PROTRACKS = 'protracks'
const ACTIVITIES = 'activities'
const SPRINTS = 'sprints'

export const GALLERY_INNER_MODIFIER = {
  [ORGANIZATION_MAIN_LOGO_IMAGE]: getGalleryOrganizationsImages,
  [ORGANIZATION_EMAIL_LOGO_IMAGE]: getGalleryEmailsImages,
  [WELCOME_EMAIL]: getGalleryEmailsImages,
  [ORG_INACTIVE_NOTIFICATIONS]: getGalleryPublicImages,
  [PROTRACK_LEVEL_IMAGE]: getGalleryProtracksImages,
  [ACTIVITY_IMAGE]: getSearchAtActivitiesImages,
  [ACTIVITY_VIDEO]: getVideosList,
  [PROTRACK_LEVEL_WELCOME_EMAIL_IMAGE]: getGalleryEmailsImages,
  [IMAGE_MESSAGING]: getGalleryEmailsImages,
  [PROMO_PAGE_SETTINGS]: getGalleryPublicImages,
  [SPRINT_BADGE]: getGallerySprintsImages,
}

export const GALLERY_S3_ENTITY = {
  [ORGANIZATION_MAIN_LOGO_IMAGE]: ORGANIZATIONS,
  [ORGANIZATION_EMAIL_LOGO_IMAGE]: EMAILS,
  [WELCOME_EMAIL]: EMAILS,
  [ORG_INACTIVE_NOTIFICATIONS]: PUBLIC,
  [PROTRACK_LEVEL_IMAGE]: PROTRACKS,
  [ACTIVITY_IMAGE]: ACTIVITIES,
  [PROTRACK_LEVEL_WELCOME_EMAIL_IMAGE]: EMAILS,
  [IMAGE_MESSAGING]: EMAILS,
  [PROMO_PAGE_SETTINGS]: PUBLIC,
  [SPRINT_BADGE]: SPRINTS,
}

export const DEFAULT_ACTIVITY_IMAGE_URL = 'https://assets.prohabits.com/constants/activityImageDefault.jpg'
